{
  "title": "Notifications",
  "description": "Stay updated with your practice notifications.",
  "unreadCount": "({{count}} unread)",
  "markAllRead": "Mark All as Read",
  "markAsRead": "Mark as read",
  "filterLabel": "Filter notifications",
  "filter": {
    "all": "All",
    "unread": "Unread",
    "read": "Read"
  },
  "time": {
    "justNow": "Just now",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago"
  },
  "empty": {
    "noNotifications": {
      "title": "No notifications yet",
      "description": "You'll receive notifications about your practice activities here"
    },
    "noUnread": {
      "title": "All caught up!",
      "description": "You have no unread notifications"
    },
    "noRead": {
      "title": "No read notifications",
      "description": "Read notifications will appear here"
    }
  },
  "errors": {
    "loadNotificationsFailed": "Failed to load notifications",
    "markAsReadFailed": "Failed to mark notification as read"
  }
}
